module.exports = __webpack_public_path__ + "img/news_img.bb315eab.png";